export const AlertType = {
	ERROR: 'error',
	SUCCESS: 'success',
	WARNING: 'warning',
};

export const AlertConfig = {
	[AlertType.ERROR]: { color: 'danger', icon: 'X' },
	[AlertType.SUCCESS]: { color: 'success', icon: 'Check' },
	[AlertType.WARNING]: { color: 'warning', icon: 'Exclamation' },
};
